import { create } from 'zustand';

export type Env = 'sandbox' | 'live';
export type Portal = 'merchant' | 'partner';

interface UiState {
  readonly env: Env;
  readonly portal: Portal;
  setEnv: (e: Env) => void;
  setPortal: (p: Portal) => void;
}

/**
 * Workspace-level UI toggles. Lives in client state only — never persisted
 * (the *real* effective env is enforced server-side on every request).
 */
export const useUiStore = create<UiState>((set) => ({
  env: 'sandbox',
  portal: 'partner',
  setEnv: (env) => {
    set({ env });
  },
  setPortal: (portal) => {
    set({ portal });
  },
}));
